import * as React from 'react';

function SvgParkedPin(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={38} height={44} viewBox="0 0 38 44" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          fill="#2F2D78"
          d="M0 2v27.758a.5.5 0 00.19.393L19 45l18.81-14.85a.5.5 0 00.19-.392V2a2 2 0 00-2-2H2a2 2 0 00-2 2z"
        />
        <path
          fill="#5F59FF"
          d="M.5 2v27.092a.5.5 0 00.19.392L19 44l18.31-14.516a.5.5 0 00.19-.392V2a2 2 0 00-2-2h-33a2 2 0 00-2 2z"
        />
        <path
          fill="#F6F6FF"
          fillRule="nonzero"
          d="M26.404 16.117V8h-3.045v8.116L19 11.843l-4.36 4.274V8h-3.045v8.116L7.24 11.844 5 14.042 13.12 22 19 16.235 24.883 22 33 14.042l-2.239-2.197z"
        />
      </g>
    </svg>
  );
}

export default SvgParkedPin;
